import { render, staticRenderFns } from "./tchlist.vue?vue&type=template&id=56c802e4&scoped=true&"
import script from "./tchlist.vue?vue&type=script&lang=js&"
export * from "./tchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c802e4",
  null
  
)

export default component.exports